/**
 * Custom Scripts - Magnetic Buttons & Footer Logo Animation
 */

/**
 * SMART HEADER SCROLL BEHAVIOR
 * - At top: ticker is visible → header gets .header--in-hero and NOT .header--sticky
 * - Once ticker has scrolled out (52px or measured height): header gets .header--sticky and loses .header--in-hero
 * - Past that point: hide on scroll down (with hysteresis), show immediately on scroll up
 * - Uses GSAP if available
 */

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header');
  if (!header) return;

  // Your ticker wrapper (from your markup)
  const ticker = document.querySelector('.marquee-header-bar');

  // If ticker not found, fall back to 52px
  const FALLBACK_TICKER_HEIGHT = 52;

  if (typeof gsap !== 'undefined') {
    header.classList.add('header--gsap-animated');
  }

  let lastScrollTop = 0;
  let scrollHideThreshold = getTickerHeight(); // ✅ threshold based on ticker height
  let scrollYWhenHeaderShown = 0;
  let isHeaderHidden = false;

  const HIDE_HYSTERESIS = 30; // px to scroll down before hiding (prevents jitter)

  // Keep threshold accurate if ticker height changes on resize/fonts/etc.
  window.addEventListener('resize', () => {
    scrollHideThreshold = getTickerHeight();
    handleScroll(); // re-evaluate immediately
  });

  function getTickerHeight() {
    if (!ticker) return FALLBACK_TICKER_HEIGHT;
    // if ticker is display:none (e.g. mobile), height will be 0 → that's fine
    return Math.ceil(ticker.getBoundingClientRect().height) || 0;
  }

  function setSticky(isSticky) {
    header.classList.toggle('header--sticky', isSticky);
  }

  function showHeader() {
    isHeaderHidden = false;

    if (typeof gsap !== 'undefined') {
      gsap.to(header, {
        yPercent: 0,
        duration: 0.35,
        ease: 'power2.out',
        overwrite: true,
        force3D: true
      });
    } else {
      header.classList.remove('header--hidden');
      header.classList.add('header--visible');
    }
  }

  function hideHeader() {
    isHeaderHidden = true;

    if (typeof gsap !== 'undefined') {
      gsap.to(header, {
        yPercent: -100,
        duration: 0.35,
        ease: 'power2.out',
        overwrite: true,
        force3D: true
      });
    } else {
      header.classList.remove('header--visible');
      header.classList.add('header--hidden');
    }
  }

  function handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // ✅ TOP STATE (ticker visible)
    // Keep your existing "hero" behavior intact: we just define "in hero" as
    // "ticker is visible at the top", not "100vh - 140px".
    if (scrollTop < scrollHideThreshold) {
      header.classList.remove('header--hidden', 'header--visible');
      header.classList.add('header--in-hero');
      setSticky(false);

      if (typeof gsap !== 'undefined') {
        gsap.killTweensOf(header);
        gsap.set(header, { yPercent: 0 });
      }

      isHeaderHidden = false;
      scrollYWhenHeaderShown = scrollTop;
      lastScrollTop = scrollTop;
      return;
    }

    // ✅ STICKY STATE (ticker gone)
    header.classList.remove('header--in-hero');
    setSticky(true);

    // Hide/show logic stays the same
    if (scrollTop > lastScrollTop) {
      // Scrolling down - hide after small hysteresis to prevent jitter
      if (!isHeaderHidden && (scrollTop - scrollYWhenHeaderShown >= HIDE_HYSTERESIS)) {
        hideHeader();
      }
    } else {
      // Scrolling up - show immediately
      if (isHeaderHidden) {
        showHeader();
        scrollYWhenHeaderShown = scrollTop;
      }
    }

    lastScrollTop = scrollTop;
  }

  let ticking = false;
  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  });

  // Initial state
  handleScroll();
});


// ═══════════════════════════════════════════════════
// MOBILE NAV: toggle .header-section.is-open (slide in/out)
// ═══════════════════════════════════════════════════

document.addEventListener('DOMContentLoaded', function() {
  var toggle = document.querySelector('[data-mobile-nav-toggle]');
  var headerSection = document.querySelector('.header-section');
  var breakpoint = 991;

  if (!toggle || !headerSection) return;

  function isMobile() {
    return window.innerWidth <= breakpoint;
  }

  toggle.addEventListener('click', function() {
    if (!isMobile()) return;
    headerSection.classList.toggle('is-open');
    toggle.classList.toggle('is-open');
    var isOpen = headerSection.classList.contains('is-open');
    toggle.setAttribute('aria-expanded', isOpen);
    document.documentElement.style.overflowY = isOpen ? 'hidden' : '';
  });

  window.addEventListener('resize', function() {
    if (!isMobile()) {
      headerSection.classList.remove('is-open');
      toggle.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflowY = '';
    }
  });
});

// ═══════════════════════════════════════════════════
// PRODUCT HERO MODALS (Ingredients, Nutrition, How to cook)
// Uses event delegation so modals work when section is in DOM at any time.
// ═══════════════════════════════════════════════════

document.addEventListener('DOMContentLoaded', function() {
  function openModal(id) {
    var modal = document.getElementById(id);
    if (!modal) return;
    modal.removeAttribute('hidden');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflowY = 'hidden';
    var triggers = document.querySelectorAll('.product-hero__modal-trigger');
    triggers.forEach(function(t) {
      t.setAttribute('aria-expanded', t.getAttribute('data-product-hero-modal') === id.replace('product-hero-modal-', '') ? 'true' : 'false');
    });
    var firstFocus = modal.querySelector('.product-hero-modal__close, [data-product-hero-modal-close]');
    if (firstFocus) firstFocus.focus();
  }

  function closeModal(modal) {
    if (!modal || !modal.classList.contains('product-hero-modal')) return;
    modal.setAttribute('hidden', '');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflowY = '';
    var triggers = document.querySelectorAll('.product-hero__modal-trigger');
    triggers.forEach(function(t) { t.setAttribute('aria-expanded', 'false'); });
  }

  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('.product-hero__modal-trigger');
    if (trigger) {
      e.preventDefault();
      var key = trigger.getAttribute('data-product-hero-modal');
      if (key) openModal('product-hero-modal-' + key);
      return;
    }
    var closeControl = e.target.closest('[data-product-hero-modal-close]');
    if (closeControl) {
      var modal = closeControl.closest('.product-hero-modal');
      closeModal(modal);
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape') return;
    var openModalEl = document.querySelector('.product-hero-modal[aria-hidden="false"]');
    if (openModalEl) closeModal(openModalEl);
  });

  // Cooking instructions accordion (How to cook modal) – slide open/close like mega menu, only one open at a time
  var COOKING_ACCORDION_DURATION = 300;
  document.addEventListener('click', function(e) {
    var toggle = e.target.closest('[data-cooking-accordion-toggle]');
    if (!toggle) return;
    var item = toggle.closest('[data-cooking-accordion-item]');
    var panel = item && item.querySelector('[data-cooking-accordion-panel]');
    if (!item || !panel) return;
    var accordion = item.closest('[data-cooking-accordion]');
    var siblings = accordion ? accordion.querySelectorAll('[data-cooking-accordion-item]') : [];
    var isOpen = item.classList.contains('is-open');
    function closeItem(otherItem) {
      if (otherItem === item) return;
      if (!otherItem.classList.contains('is-open')) return;
      var otherPanel = otherItem.querySelector('[data-cooking-accordion-panel]');
      var otherToggle = otherItem.querySelector('[data-cooking-accordion-toggle]');
      if (typeof jQuery !== 'undefined' && otherPanel) {
        jQuery(otherPanel).slideUp(COOKING_ACCORDION_DURATION, function() {
          otherPanel.setAttribute('hidden', '');
          otherItem.classList.remove('is-open');
          if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
        });
      } else if (otherPanel) {
        otherPanel.setAttribute('hidden', '');
        otherItem.classList.remove('is-open');
        if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
      }
    }
    if (typeof jQuery === 'undefined') {
      if (isOpen) {
        item.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        panel.setAttribute('hidden', '');
      } else {
        for (var i = 0; i < siblings.length; i++) closeItem(siblings[i]);
        item.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        panel.removeAttribute('hidden');
      }
      return;
    }
    var $panel = jQuery(panel);
    if (isOpen) {
      $panel.slideUp(COOKING_ACCORDION_DURATION, function() {
        panel.setAttribute('hidden', '');
        item.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    } else {
      for (var j = 0; j < siblings.length; j++) closeItem(siblings[j]);
      panel.removeAttribute('hidden');
      $panel.hide().slideDown(COOKING_ACCORDION_DURATION);
      item.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    }
  });
});

// ═══════════════════════════════════════════════════
// TEXT ANIMATION SYSTEM
// ═══════════════════════════════════════════════════

if (typeof gsap !== 'undefined' && typeof SplitText !== 'undefined') {
  gsap.registerPlugin(SplitText, ScrollTrigger);

  window.addEventListener("DOMContentLoaded", () => {
    const elements = document.querySelectorAll('[text-split]');

    elements.forEach((el) => {
      const animName = el.getAttribute("animation");
      if (!animName || animName !== "lines-clip-up") return;

      // Check if already animated
      if (el.dataset.splitAnimationComplete) return;

      // Clean up any previous animation
      const prevTl = el._splitTimeline;
      if (prevTl) {
        if (prevTl.scrollTrigger) prevTl.scrollTrigger.kill();
        prevTl.kill();
      }

      const prevSplit = el._split;
      if (prevSplit && prevSplit.revert) prevSplit.revert();

      // Split text into lines only
      const split = new SplitText(el, {
        type: "lines",
        linesClass: "line"
      });

      el._split = split;

      // Set initial state - lines pushed down and clipped
      gsap.set(split.lines, {
        yPercent: 100,
        clipPath: "inset(0% 0% 100% 0%)",
        transformOrigin: "50% 100%"
      });

      // Make element visible
      gsap.set(el, { opacity: 1 });

      // Create animation timeline
      const tl = gsap.timeline({
        defaults: { duration: 1, ease: "expo.out" },
        scrollTrigger: {
          trigger: el,
          start: "top 90%",
          end: "bottom 75%",
          toggleActions: "play none none none",
          once: true
        },
        onComplete: () => {
          el.dataset.splitAnimationComplete = "true";
        }
      });

      // Animate lines up with clip-path reveal
      tl.fromTo(split.lines,
        {
          yPercent: 100,
          clipPath: "inset(0% 0% 100% 0%)",
          transformOrigin: "50% 100%"
        },
        {
          yPercent: 0,
          clipPath: "inset(0% -3% -10% -3%)",
          stagger: 0.1,
          immediateRender: false
        }
      );

      el._splitTimeline = tl;
    });
  });
}

// ═══════════════════════════════════════════════════
// BUTTON CLIP-PATH REVEAL EFFECT
// ═══════════════════════════════════════════════════

if (typeof gsap !== 'undefined') {
  document.addEventListener('DOMContentLoaded', () => {
    const buttons = document.querySelectorAll('[data-btn="wrap"]');
    
    buttons.forEach(btn => {
      const clipEl = btn.querySelector('[data-btn="clip"]');
      
      if (!clipEl) return;
      
      clipEl.setAttribute('aria-hidden', 'true');
      
      const durationSetting = 1.1;
      const easeSetting = 'power3.out';
      
      // Calculate mouse position as percentage
      function getPercentTop(el, e) {
        const rect = el.getBoundingClientRect();
        const elTop = rect.top;
        const mouseTop = e.clientY - elTop;
        return (mouseTop / rect.height) * 100;
      }
      
      function getPercentLeft(el, e) {
        const rect = el.getBoundingClientRect();
        const elLeft = rect.left;
        const mouseLeft = e.clientX - elLeft;
        return (mouseLeft / rect.width) * 100;
      }
      
      btn.addEventListener('mouseenter', (e) => {
        const percentTop = getPercentTop(btn, e);
        const percentLeft = getPercentLeft(btn, e);
        
        gsap.set(clipEl, { display: 'flex' });
        gsap.fromTo(
          clipEl,
          { clipPath: `circle(0% at ${percentLeft}% ${percentTop}%)` },
          {
            clipPath: `circle(140% at ${percentLeft}% ${percentTop}%)`,
            duration: durationSetting,
            ease: easeSetting,
          }
        );
      });
      
      btn.addEventListener('mouseleave', (e) => {
        const percentTop = getPercentTop(btn, e);
        const percentLeft = getPercentLeft(btn, e);
        
        gsap.to(clipEl, {
          clipPath: `circle(0% at ${percentLeft}% ${percentTop}%)`,
          overwrite: true,
          duration: durationSetting,
          ease: easeSetting,
        });
      });
    });
  });
} else {
  console.error('GSAP not loaded!');
}

(function () {
  const FORM_TESTID = "klaviyo-form-UUwi4W";
  const INIT_ATTR = "data-btn-initialized";

  function enhanceKlaviyoButton(formEl) {
    const btn = formEl.querySelector('button[type="button"]');
    const hiddenSubmit = formEl.querySelector('input[type="submit"]');
    if (!btn || !hiddenSubmit) return;

    if (btn.getAttribute(INIT_ATTR) === "1") return;
    btn.setAttribute(INIT_ATTR, "1");

    // Add your classes + hook attribute (your global script will pick it up)
    btn.classList.add("btn", "btn--pill", "btn-primary");
    btn.setAttribute("data-btn", "wrap");

    // Build required inner HTML (with duplicated text in clip)
    const originalText = btn.textContent.trim();
    btn.textContent = "";

    const textEl = document.createElement("span");
    textEl.className = "btn__text";
    textEl.textContent = originalText;

    const clipEl = document.createElement("span");
    clipEl.className = "btn__clip";
    clipEl.setAttribute("data-btn", "clip");
    clipEl.setAttribute("aria-hidden", "true");

    const clipText = document.createElement("span");
    clipText.className = "btn__text";
    clipText.textContent = originalText;

    clipEl.appendChild(clipText);
    btn.appendChild(textEl);
    btn.appendChild(clipEl);

    // Submit via Klaviyo hidden submit
    btn.addEventListener("click", () => hiddenSubmit.click());
  }

  function tryInit() {
    const formEl = document.querySelector(`[data-testid="${FORM_TESTID}"]`);
    if (!formEl) return;
    enhanceKlaviyoButton(formEl);
  }

  document.addEventListener("DOMContentLoaded", tryInit);
  const obs = new MutationObserver(tryInit);
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();

if (typeof gsap !== 'undefined') {
  const INIT_ATTR = 'data-clip-init';

  function initButtons() {
    document.querySelectorAll('[data-btn="wrap"]').forEach(btn => {
      if (btn.getAttribute(INIT_ATTR) === '1') return;
      btn.setAttribute(INIT_ATTR, '1');

      const clipEl = btn.querySelector('[data-btn="clip"]');
      if (!clipEl) return;

      clipEl.setAttribute('aria-hidden', 'true');

      const durationSetting = 1.1;
      const easeSetting = 'power3.out';

      function getPercentTop(el, e) {
        const rect = el.getBoundingClientRect();
        return ((e.clientY - rect.top) / rect.height) * 100;
      }

      function getPercentLeft(el, e) {
        const rect = el.getBoundingClientRect();
        return ((e.clientX - rect.left) / rect.width) * 100;
      }

      btn.addEventListener('mouseenter', (e) => {
        const percentTop = getPercentTop(btn, e);
        const percentLeft = getPercentLeft(btn, e);

        gsap.set(clipEl, { display: 'flex' });
        gsap.fromTo(
          clipEl,
          { clipPath: `circle(0% at ${percentLeft}% ${percentTop}%)` },
          {
            clipPath: `circle(140% at ${percentLeft}% ${percentTop}%)`,
            duration: durationSetting,
            ease: easeSetting,
            overwrite: 'auto'
          }
        );
      });

      btn.addEventListener('mouseleave', (e) => {
        const percentTop = getPercentTop(btn, e);
        const percentLeft = getPercentLeft(btn, e);

        gsap.to(clipEl, {
          clipPath: `circle(0% at ${percentLeft}% ${percentTop}%)`,
          overwrite: true,
          duration: durationSetting,
          ease: easeSetting,
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initButtons);
  const obs = new MutationObserver(initButtons);
  obs.observe(document.documentElement, { childList: true, subtree: true });
}


// ═══════════════════════════════════════════════════
// MEGA MENU (desktop: GSAP | mobile ≤991px: jQuery accordion slideDown/slideUp)
// ═══════════════════════════════════════════════════

var MEGA_MENU_BREAKPOINT = 991;
var MEGA_MENU_ACCORDION_DURATION = 300;

document.addEventListener('DOMContentLoaded', function() {
  var trigger = document.querySelector('[data-mega-menu-trigger]');
  if (!trigger) return;

  var megaMenu = trigger.closest('.header__nav-item') && trigger.closest('.header__nav-item').querySelector('[data-mega-menu]');
  var panel = megaMenu && megaMenu.querySelector('[data-mega-menu-panel]');
  var overlay = document.querySelector('[data-mega-menu-overlay]');

  if (!megaMenu || !panel) return;

  var isOpen = false;
  var tl = null;

  function isMobile() {
    return window.innerWidth <= MEGA_MENU_BREAKPOINT;
  }

  function useAccordion() {
    return typeof jQuery !== 'undefined' && isMobile();
  }

  function initDesktop() {
    if (tl) {
      tl.kill();
      tl = null;
    }
    if (typeof gsap === 'undefined') {
      panel.style.opacity = '';
      panel.style.visibility = '';
      return;
    }
    gsap.set(panel, {
      opacity: 0,
      visibility: 'hidden',
      maxHeight: 'none',
      overflow: 'visible',
      display: ''
    });
    if (overlay) {
      gsap.set(overlay, { opacity: 0, visibility: 'hidden' });
    }
    tl = gsap.timeline({ paused: true });
    tl.to(panel, {
      opacity: 1,
      visibility: 'visible',
      duration: 0.3,
      ease: 'power1.inOut'
    });
    if (overlay) {
      tl.to(overlay, {
        opacity: 1,
        visibility: 'visible',
        duration: 0.3,
        ease: 'power1.inOut'
      }, 0);
    }
  }

  function openMenu() {
    if (isOpen) return;
    isOpen = true;
    megaMenu.classList.add('is-active');
    trigger.classList.add('is-active');
    document.documentElement.style.overflowY = 'hidden';
    if (tl) {
      tl.progress(0);
      tl.play();
    } else {
      panel.style.visibility = 'visible';
      panel.style.opacity = '1';
      if (overlay) {
        overlay.style.visibility = 'visible';
        overlay.style.opacity = '1';
      }
    }
  }

  function closeMenu() {
    if (!isOpen) return;
    isOpen = false;
    document.documentElement.style.overflowY = '';
    if (tl) {
      tl.reverse();
      setTimeout(function() {
        megaMenu.classList.remove('is-active');
        trigger.classList.remove('is-active');
      }, 300);
    } else {
      megaMenu.classList.remove('is-active');
      trigger.classList.remove('is-active');
      panel.style.visibility = 'hidden';
      panel.style.opacity = '0';
      if (overlay) {
        overlay.style.visibility = 'hidden';
        overlay.style.opacity = '0';
      }
    }
  }

  function toggleMenu(e) {
    e.preventDefault();
    if (useAccordion()) {
      var $panel = jQuery(panel);
      if (megaMenu.classList.contains('is-active')) {
        $panel.slideUp(MEGA_MENU_ACCORDION_DURATION, function() {
          megaMenu.classList.remove('is-active');
          trigger.classList.remove('is-active');
        });
        isOpen = false;
      } else {
        $panel.slideDown(MEGA_MENU_ACCORDION_DURATION);
        megaMenu.classList.add('is-active');
        trigger.classList.add('is-active');
        isOpen = true;
      }
    } else {
      if (isOpen) closeMenu();
      else openMenu();
    }
  }

  function initAccordion() {
    // Mobile: panel is only display + slideDown/slideUp — no opacity or visibility
    panel.style.opacity = '';
    panel.style.visibility = '';
    panel.style.display = '';
    if (typeof gsap !== 'undefined') gsap.set(panel, { clearProps: 'all' });
    if (typeof jQuery !== 'undefined') jQuery(panel).hide();
  }

  if (useAccordion()) {
    initAccordion();
    megaMenu.classList.add('mega-menu--accordion');
  } else if (typeof gsap !== 'undefined') {
    initDesktop();
  }

  trigger.addEventListener('click', toggleMenu);

  if (overlay) {
    overlay.addEventListener('click', function() {
      if (!useAccordion()) closeMenu();
      else {
        jQuery(panel).slideUp(MEGA_MENU_ACCORDION_DURATION);
        megaMenu.classList.remove('is-active');
        trigger.classList.remove('is-active');
        isOpen = false;
      }
    });
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && isOpen) {
      if (useAccordion()) {
        jQuery(panel).slideUp(MEGA_MENU_ACCORDION_DURATION);
        megaMenu.classList.remove('is-active');
        trigger.classList.remove('is-active');
        isOpen = false;
      } else {
        closeMenu();
      }
    }
  });

  [].forEach.call(panel.querySelectorAll('.mega-menu__card'), function(card) {
    card.addEventListener('click', function() {
      setTimeout(function() {
        if (useAccordion()) {
          jQuery(panel).slideUp(MEGA_MENU_ACCORDION_DURATION);
          megaMenu.classList.remove('is-active');
          trigger.classList.remove('is-active');
          isOpen = false;
        } else {
          closeMenu();
        }
      }, 100);
    });
  });

  window.addEventListener('resize', function() {
    var nowAccordion = useAccordion();
    var wasAccordion = megaMenu.classList.contains('mega-menu--accordion');
    if (nowAccordion === wasAccordion) return;
    if (isOpen) {
      if (wasAccordion && typeof jQuery !== 'undefined') {
        jQuery(panel).slideUp(0);
      } else if (tl) {
        tl.reverse();
      }
      megaMenu.classList.remove('is-active');
      trigger.classList.remove('is-active');
      document.documentElement.style.overflowY = '';
      isOpen = false;
    }
    if (nowAccordion) {
      if (tl) {
        tl.kill();
        tl = null;
      }
      initAccordion();
      megaMenu.classList.add('mega-menu--accordion');
    } else {
      megaMenu.classList.remove('mega-menu--accordion');
      if (typeof jQuery !== 'undefined') {
        jQuery(panel).show().css({ visibility: '', opacity: '' });
      }
      initDesktop();
    }
  });
});

// ═══════════════════════════════════════════════════
// TEXT-IMAGE VIDEO HOVER (desktop) + TAP TO TOGGLE (mobile)
// ═══════════════════════════════════════════════════

document.addEventListener('DOMContentLoaded', () => {
  const videoTriggers = document.querySelectorAll('[data-video-trigger]');
  
  function showVideo(trigger, videoContainer, video, iframe) {
    videoContainer.classList.add('is-visible');
    if (video) {
      video.play().catch(function(err) {});
    } else if (iframe && iframe.hasAttribute('data-src') && !iframe.src) {
      iframe.src = iframe.getAttribute('data-src');
    }
  }

  function hideVideo(videoContainer, video, iframe) {
    videoContainer.classList.remove('is-visible');
    if (video) {
      video.pause();
      video.currentTime = 0;
    } else if (iframe && iframe.src) {
      var currentSrc = iframe.src;
      iframe.src = '';
      iframe.src = currentSrc;
    }
  }

  videoTriggers.forEach(function(trigger) {
    const parentItem = trigger.closest('.text-image__text-item--has-video');
    if (!parentItem) return;
    
    const videoContainer = parentItem.querySelector('[data-video-container]');
    if (!videoContainer) return;
    
    const video = videoContainer.querySelector('video');
    const iframe = videoContainer.querySelector('iframe');
    
    // Desktop: hover to show, leave to hide
    trigger.addEventListener('mouseenter', function() {
      showVideo(trigger, videoContainer, video, iframe);
    });
    
    trigger.addEventListener('mouseleave', function() {
      hideVideo(videoContainer, video, iframe);
    });
    
    // Mobile / touch: tap to toggle (devices without hover use click to show/hide video)
    trigger.addEventListener('click', function(e) {
      if (!window.matchMedia('(hover: none)').matches) return;
      var isVisible = videoContainer.classList.contains('is-visible');
      if (isVisible) {
        hideVideo(videoContainer, video, iframe);
      } else {
        showVideo(trigger, videoContainer, video, iframe);
      }
      e.preventDefault();
    });
  });
});

// ═══════════════════════════════════════════════════
// PRODUCT HERO SLIDER
// ═══════════════════════════════════════════════════

function initProductSlider() {

  const productHeroSlider = document.querySelector('.product-hero__slider');
  
    if (!productHeroSlider) {
      return;
    }
    
    const productHeroSwiper = new Swiper('.product-hero__slider', {
      slidesPerView: 1,
      centeredSlides: true,
      navigation: {
        nextEl: '.product-hero__arrow--next',
        prevEl: '.product-hero__arrow--prev',
      },
      loop: true,
      speed: 400,
      effect: 'fade',
    });

    return productHeroSwiper;
}



// Initialize slider when DOM is ready or immediately if already loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductSlider);
} else {
  // DOM is already loaded
  initProductSlider();
}

// ═══════════════════════════════════════════════════
// PAGE HEADER (HERO) PARALLAX EFFECT
// ═══════════════════════════════════════════════════

if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
  gsap.registerPlugin(ScrollTrigger);

  document.addEventListener('DOMContentLoaded', () => {
    const heroImg = document.querySelector('.hero-section .hero__image img');

    if (!heroImg) {
      return;
    }

    gsap.set(heroImg, { yPercent: -10 });

    gsap.to(heroImg, {
      yPercent: 10,
      ease: 'none',
      scrollTrigger: {
        trigger: heroImg.closest('.hero'),
        start: 'top bottom',
        end: 'bottom top',
        scrub: 1,
      }
    });
  });
}

// ═══════════════════════════════════════════════════
// PRODUCT CARDS PARALLAX EFFECT
// ═══════════════════════════════════════════════════

// if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
//   gsap.registerPlugin(ScrollTrigger);

//   document.addEventListener('DOMContentLoaded', () => {
//     const productCards = document.querySelectorAll('.product-card__image img');
    
//     productCards.forEach(img => {
//       // Set initial position
//       gsap.set(img, { yPercent: -10 });
      
//       // Animate from -10% to +10% on scroll
//       gsap.to(img, {
//         yPercent: 10,
//         ease: 'none',
//         scrollTrigger: {
//           trigger: img.closest('.product-card'),
//           start: 'top bottom',
//           end: 'bottom top',
//           scrub: 1,
//         }
//       });
//     });
//   });
// }

// ═══════════════════════════════════════════════════
// FOOTER LOGO WAVE ANIMATION
// ═══════════════════════════════════════════════════

if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
  gsap.registerPlugin(ScrollTrigger);

  document.addEventListener('DOMContentLoaded', () => {
    const footerLogo = document.querySelector('.footer-logo svg');
    
    if (!footerLogo) {
      return;
    }

    // Select direct children (paths and groups) of the SVG
    const elements = footerLogo.querySelectorAll(':scope > path, :scope > g');
    
    if (elements.length === 0) {
      return;
    }

    // Set initial state - elements start below viewport with rotation
    gsap.set(elements, {
      y: 150,
      rotation: 15,
      opacity: 0
    });

    // Create the wave animation with sequential stagger
    gsap.to(elements, {
      y: 0,
      rotation: 0,
      opacity: 1,
      duration: 0.6,
      ease: 'back.out(1.2)',
      stagger: 0.08,
      scrollTrigger: {
        trigger: '.footer-logo',
        start: 'top bottom-=50px', // Start when logo is 50px from viewport bottom
        end: 'top center',
        toggleActions: 'play none none reverse',
        invalidateOnRefresh: true, // Recalculate after social feed setup
        refreshPriority: -1 // Calculate after social feed ScrollTrigger
      }
    });
  });
}

if (typeof $ !== 'undefined') {
  $(document).ready(function() {
$('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000);
      }
    }
  });
  });
}

let productsSwiper = null;

function cacheOriginalInlineStyles(container) {
  // Cache inline styles so we can restore them after Swiper destroys itself
  container.querySelectorAll("[style]").forEach((el) => {
    if (!el.dataset.origStyle) el.dataset.origStyle = el.getAttribute("style") || "";
  });
}

function restoreOriginalInlineStyles(container) {
  // Restore cached styles, and only if we cached them earlier
  container.querySelectorAll("[data-orig-style]").forEach((el) => {
    const original = el.dataset.origStyle;
    if (original) el.setAttribute("style", original);
    else el.removeAttribute("style");
    delete el.dataset.origStyle;
  });
}

function initProductsSwiper() {
  if (typeof Swiper === "undefined") return;

  const container = document.querySelector(".product-mobile-slider");
  if (!container) return;

  if (window.innerWidth > 768) return;
  if (productsSwiper) return;

  // ✅ cache your Liquid inline styles BEFORE Swiper starts adding widths/transforms
  cacheOriginalInlineStyles(container);

  productsSwiper = new Swiper(container, {
    slidesPerView: 1,
    centeredSlides: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    loop: container.querySelectorAll(".swiper-slide").length > 1,
    speed: 400,
  });
}

function destroyProductsSwiper() {
  if (!productsSwiper) return;

  const container = document.querySelector(".product-mobile-slider");
  productsSwiper.destroy(true, true);
  productsSwiper = null;

  if (!container) return;

  // ✅ remove only Swiper classes (safe)
  container.classList.remove("swiper-initialized", "swiper-horizontal", "swiper-backface-hidden");

  // ✅ restore your original inline styles (keeps --card-bg, --btn-text, etc.)
  restoreOriginalInlineStyles(container);
}

function handleProductsSwiperMode() {
  if (window.innerWidth <= 768) initProductsSwiper();
  else destroyProductsSwiper();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", handleProductsSwiperMode);
} else {
  handleProductsSwiperMode();
}

let resizeTimer;
window.addEventListener("resize", () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(handleProductsSwiperMode, 200);
});
